import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink, useParams } from "react-router-dom";
import { useLocation } from "react-router";
import { folder as folderMock, Id } from "@planzone/dto";

import { ReportIcon } from "@common/assets/reportIcon";
import { getSelectedFolderPath } from "../utils";
import { Props } from "./types";
import { DirectoryStructure } from "./directoryStructure";
import styles from "./styles.scss";

function SideBar({ planzone, documents }: Props) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { folderId = "" } = useParams<{ folderId: Id }>();
  const { path } = React.useMemo(
    () => getSelectedFolderPath({ uuid: folderId, ...folderMock }, documents),
    [folderId],
  );
  const isInReport = /\/reports$/.test(pathname);

  return (
    <div className={styles.sideBar}>
      <NavLink
        to="/documents/reports"
        className={() =>
          classNames(styles.link, { [styles.active]: isInReport })
        }
      >
        <ReportIcon className={styles.icon} />
        <p>{t("documentsPage.sideBar.reports")}</p>
      </NavLink>
      <div className={styles.directoryStructure}>
        <DirectoryStructure
          planzone={planzone}
          folder={documents}
          selectedFolderId={folderId || (!isInReport ? documents.uuid : "")}
          selectedFolderPath={path}
          isRoot
        />
      </div>
    </div>
  );
}

export { SideBar };
